import React from 'react';
import PageHeader from '../components/PageHeader';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-extrabold text-gray-900">Privacy Policy</h1>
          <div className="mt-8 prose prose-indigo">
            <p className="text-lg text-gray-500">Last updated: March 1, 2024</p>
            
            <h2 className="text-xl font-bold mt-8 mb-4">1. Information We Collect</h2>
            <p>We collect information that you provide directly to us, including:</p>
            <ul className="list-disc pl-5 mt-2">
              <li>Healthcare provider information and credentials</li>
              <li>Account credentials</li>
              <li>EMR integration configuration data</li>
              <li>System logs and technical information</li>
              <li>Healthcare provider payment information</li>
            </ul>

            <h2 className="text-xl font-bold mt-8 mb-4">2. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul className="list-disc pl-5 mt-2">
              <li>Provide and maintain our services</li>
              <li>Facilitate EMR and CRM integration</li>
              <li>Monitor system performance and security</li>
              <li>Send technical notifications and system alerts</li>
              <li>Provide integration support and updates</li>
            </ul>

            <h2 className="text-xl font-bold mt-8 mb-4">3. Information Sharing</h2>
            <p>We adhere to strict HIPAA guidelines and never sell healthcare data. Information sharing is limited to:</p>
            <ul className="list-disc pl-5 mt-2">
              <li>Authorized integration partners</li>
              <li>HIPAA-compliant service providers</li>
              <li>Regulatory authorities when legally required</li>
            </ul>

            <h2 className="text-xl font-bold mt-8 mb-4">4. Data Security</h2>
            <p>
              We maintain strict HIPAA compliance and implement enterprise-grade security measures to protect all healthcare data.
              This includes end-to-end encryption, access controls, and regular security audits.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4">5. Your Rights</h2>
            <p>You have the right to:</p>
            <ul className="list-disc pl-5 mt-2">
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Receive detailed system audit logs</li>
              <li>Request data portability</li>
            </ul>

            <h2 className="text-xl font-bold mt-8 mb-4">6. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at:
              <br />
              <a href="mailto:jennifer@zonedm.com" className="text-indigo-600 hover:text-indigo-500">
                jennifer@zonedm.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
